import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-page"]
const _hoisted_2 = { style: {"line-height":"0"} }
const _hoisted_3 = ["href"]

import { type PropType } from "vue";
import { type IAdvertItem } from "../../list-item";
import advertImage from "../common/advert-image.vue";


const __default__ = {
    model: {
        prop: "item",
    },
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'advert',
  props: {
    item: {
        type: Object as PropType<IAdvertItem>,
        required: true,
    },
    mobile: Boolean,
    scaleOfScreen: {
        type: Number,
        default: 1,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(['advert-item']),
    "data-item-type": "advert",
    "data-page": __props.item.page
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: __props.item.link,
        target: "_blank",
        class: "advert-link"
      }, [
        _createVNode(advertImage, {
          mobile: __props.mobile,
          item: __props.item,
          "scale-of-screen": __props.scaleOfScreen
        }, null, 8 /* PROPS */, ["mobile", "item", "scale-of-screen"])
      ], 8 /* PROPS */, _hoisted_3)
    ])
  ], 8 /* PROPS */, _hoisted_1))
}
}

})